import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { AmountDTO } from 'gw-edge-client/dist/types/dto/pc/edge/capabilities/currency/dto';

const paymentFrequencyMap: Record<string, DSSPaymentFrequency> = {
    annual: 'annual',
    monthly: 'monthly',
    onetime: 'onetime'
} as const;

const periodicityUnit: Record<DSSPaymentFrequency, string> = {
    annual: '/år',
    monthly: '/md.',
    onetime: ''
};

const getCurrencyString = (price: number, currencyString: string, decimal: number = 0): string => {
    return price.toLocaleString('da-dk', { minimumFractionDigits: decimal }) + currencyString;
};

const convertAmountDtoToString = (amountDto: AmountDTO | undefined, digits: number = 2): string => {
    if (amountDto?.currency && amountDto?.amount) {
        const price = amountDto.amount?.toFixed(digits).toString();
        return price?.concat(' kr.').replace('.', ',') ?? '';
    }
    return '';
};

export { periodicityUnit, paymentFrequencyMap, convertAmountDtoToString, getCurrencyString };
